import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "accout-action animate__animated animate__flipInX animate__fast"
};
import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { loginByAccoutApi } from '@/service/modules/login';
import { ElForm } from 'element-plus';
import useLoginStore from '@/store/modules/login';
export default /*@__PURE__*/_defineComponent({
  __name: 'accout-action',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const loginStore = useLoginStore();
    const accoutForm = reactive({
      username: '',
      password: ''
    });
    const rules = {
      username: [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }]
    };
    const loginStatus = ref(false);
    const accoutFormRef = ref();
    function handleLogin() {
      accoutFormRef.value?.validate(valid => {
        if (valid) loginByAccoutFn();
      });
      // loginByAccoutFn()
    }
    async function loginByAccoutFn() {
      loginStatus.value = true;
      try {
        let res = await loginByAccoutApi(accoutForm);
        loginStore.loginAction(res.data);
      } catch {} finally {
        loginStatus.value = false;
      }
    }
    onMounted(() => {
      let query = route.query;
      // console.log('query', query)
      loginStore.redirect = query.redirect;
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        ref_key: "accoutFormRef",
        ref: accoutFormRef,
        model: accoutForm,
        rules: rules,
        "label-width": "70px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "账号",
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入账号",
            modelValue: accoutForm.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => accoutForm.username = $event),
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "密码",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入密码",
            modelValue: accoutForm.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => accoutForm.password = $event),
            size: "large",
            type: "password",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-top": "40px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: loginStatus.value,
            size: "large",
            type: "primary",
            class: "w100",
            onClick: handleLogin
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("登 录")])),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});